<template>
  <v-app>
    <v-card v-if="opportunity!=undefined" style="max-height:100vh; max-height: 100vh; overflow-y: scroll;">
      <v-toolbar class="px-4">
          <v-btn icon class="elevation-0" @click="$emit('close')">
            <v-icon>mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-card-title>{{opportunity.opportunity_name}}</v-card-title>
          <v-btn icon variant="text" @click="copyLink">
            <v-icon size="x-small">mdi-content-copy</v-icon>
          </v-btn>
          <v-spacer/>
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" icon class="elevation-0">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-card min-width="300" class="px-4">
              <v-card-subtitle class="mt-4 mb-3">Acciones</v-card-subtitle>
              <v-divider></v-divider>
              <v-list style="text-align:right;">
                <v-list-item v-if="$can('opportunities.update')" @click="editItem(opportunity)">
                  <v-list-item-title>Editar Oportunidad</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="$can('opportunities.delete')" @click="deleteItem(opportunity)">
                  <v-list-item-title>Eliminar Oportunidad</v-list-item-title>
                </v-list-item>
                <v-list-item  @click="sendMediaKit(opportunity)">
                  <v-list-item-title>Enviar Media Kit</v-list-item-title>
                </v-list-item>
                <v-list-item @click="changeStatusToLose(opportunity.id)">
                  <v-list-item-title>Oportuniad Perdida</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
      </v-toolbar>
      <v-card-text>
        <v-row class="ma-0">
          <div>
            <v-card-title>
              <v-icon size="small">mdi-office-building-outline</v-icon>
              {{ opportunity?.subject?.attributes?.commercial_name || opportunity?.subject?.attributes?.name }}
            </v-card-title>
            <v-card-subtitle>
              <v-icon size="x-small">mdi-information-variant-circle-outline</v-icon>
              En {{ opportunity?.current_status?.name }} desde hace {{ statusTime }}
            </v-card-subtitle>
          </div>
          <v-spacer/>
          <v-chip v-if="opportunity?.subject?.type  == 'leads'" color="#efddff" label class="mt-4">
            Lead
          </v-chip>
          <v-chip v-else-if="opportunity?.subject?.type  == 'clients'" color="#c8dcff" label class="mt-4">
            Cliente
          </v-chip>
        </v-row>
        <div class="py-2 px-4">
          <v-chip v-bind="props" link pill size="x-small">
            <v-avatar class="pa-1" start>
              <v-img style="border-radius:50%!important;" src="https://ionicframework.com/docs/img/demos/avatar.svg"></v-img>
            </v-avatar>
            {{opportunity?.user?.name + (opportunity?.user?.last_name!=null?(' ' + opportunity?.user?.last_name):'')}}
          </v-chip>
          <v-card-title class="pl-0">Interes(es)</v-card-title>
          <div v-for="(group, index) in groupedProductsByOrganization" :key="index">
            <v-row class="ma-0 mb-2">
              <v-avatar size="30px" start>
                <v-img :src="group?.organization?.logo_isotype"/>
              </v-avatar>
              <v-card-subtitle class="py-1 px-2">{{ group?.organization?.name }}</v-card-subtitle>
            </v-row>
            <v-chip v-for="(product, idx) in group.products" label :key="idx" class="mr-2" size="small">
              {{ product.description }}
            </v-chip>
          </div>
        </div>

        <div v-if="opportunity.description!=null">
          <v-card-subtitle>Descripción</v-card-subtitle>
          <v-card class="elevation-0 pa-4">
            {{opportunity.description}}
          </v-card>
        </div>

        <div>
          <v-tabs v-model="selectedInteractionType" align-tabs="center">
            <v-tab v-for="(type, index) in interactionTypes" :key="index" :value="type.value">{{ type.label }} ({{ type.count }})</v-tab>
          </v-tabs>
        </div>
        <v-row class="ma-0 mt-6">
          <v-col cols="12" md="8">
            <v-timeline truncate-line="both" align="start" side="end">
              <v-timeline-item size="x-small" v-for="(item, index) in filteredInteractions" :key="index">
                <template v-slot:opposite>
                  <div style="min-width:150px;">
                    <strong>{{item?.interaction_type}}</strong>
                    <div class="text-caption">
                      <v-icon size="x-small" class="mr-1">mdi-calendar</v-icon>{{ $dateFormat((item.created_at || item.date)?.slice(0,10)) }}
                    <br/>
                      <v-icon size="x-small" class="mr-1">mdi-clock</v-icon>{{ $hourFormat((item.created_at || item.date)?.slice(11,20)) }}
                    </div>
                  </div>
                </template>
                <v-card width="600" class="elevation-0" v-if="item?.interaction_type=='Status'">
                  <v-chip>{{item.name}}</v-chip>
                  <v-row v-if="item.additional_data!=null&&item.additional_data!='null'&&item.additional_data.length>0" class="ma-0 mt-3">
                    <v-card-subtitle>Evidencia:</v-card-subtitle> 
                    <v-btn variant="tonal" size="x-small" v-for="(data, index) in JSON.parse(item.additional_data)" :key="index" :href="data.file" target="_blank">
                      <v-icon size="small" class="mr-1">mdi-download</v-icon>
                      {{data.label}}
                    </v-btn>
                  </v-row>
                </v-card>
                <!-- Actividad -->
                <v-card width="600" class="elevation-0" v-else-if="item.interaction_type === 'Actividad'" @click="openDetailDialog(item.id, 'Activities')">
                  <div class="text-caption font-weight-medium">{{ item.type }}</div>
                  <div class="text-caption">{{ $dateFormat(item.only_date) }} {{ $hourFormat(item.only_time) }}</div>
                  <div class="text-caption">{{ item.description }}</div>
                  <div v-if="item.completed_at" class="text-caption">
                    Se completó el {{ $dateFormat(item.completed_at.slice(0, 10)) }} a las {{ $hourFormat(item.completed_at.slice(11, 20)) }}
                  </div>
                  <div v-if="item.user" class="text-caption">
                    {{ item.user.name }} {{ item.user.last_name }}
                  </div>
                </v-card>

                <!-- Cotización o Venta -->
                <v-card width="600" class="elevation-0" v-else-if="item.interaction_type === 'Cotización' || item.interaction_type === 'Venta'"><!--  @click="openDetailDialog('viewItem', item.id, (item.interaction_type === 'Cotización' ? 'quotations' : item.interaction_type === 'Venta' ? 'sales' : ''))"-->
                  <div class="text-caption">ID: {{ item.id }}</div>
                  <div v-if="item.user" class="text-caption">
                    Vendedor: {{ item.user.name }} {{ item.user.last_name }}
                  </div>
                  <div class="text-caption">Subtotal: {{ $toCurrency(item.subtotal) }}</div>
                  <div class="text-caption">IVA: {{ $toCurrency(item.iva) }}</div>
                  <div class="text-caption">Total: {{ $toCurrency(item.total) }}</div>

                  <!-- Autorización -->
                  <div v-if="item.needs_authorization">
                    <div class="text-caption">Total Sugerido: {{ $toCurrency(item.suggested_total) }}</div>
                    <div v-if="item.authorized_by">
                      <div class="text-caption">
                        Autorizado el {{ $dateFormat(item.authorized_at.slice(0,10)) }} a las {{ $hourFormat(item.authorized_at.slice(11,20)) }}
                      </div>
                      <div class="text-caption">
                        Autorizado por {{ item.authorized_by.name }} {{ item.authorized_by.last_name }}
                      </div>
                    </div>
                    <div v-else class="text-caption text-red">Requiere Autorización</div>
                  </div>

                  <!-- Extras -->
                  <div v-if="item.payment_method" class="text-caption">Método de pago: {{ item.payment_method }}</div>
                  <div v-if="item.notes" class="text-caption">Notas: {{ item.notes }}</div>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-col>
          <v-col cols="4">
            <contactInfo :style="device >= 768?'width:30%;':'display:none;'" v-if="opportunity?.subject?.type == 'clients'" :selected_client="opportunity?.subject"/>
            <leadInfo :style="device >= 768?'width:30%;':'display:none;'" v-if="opportunity?.subject?.type == 'leads'" :selected_lead="opportunity?.subject"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-fab v-if="$can('activities.create')||$can('quotations.create')" style="position: fixed;" key="fixed" :absolute="false" :app="true" :color="open ? '' : 'primary'" location="right bottom" size="large" icon class="mr-4">
        <v-icon>{{ open ? 'mdi-close' : 'mdi-plus' }}</v-icon>
        <v-speed-dial v-model="open" :location="menuLocation" :transition="transition" activator="parent">
          <v-tooltip location="left" v-if="$can('quotations.create')">
            <template #activator="{ props }">
              <v-btn color="grey" class="mb-2" icon v-bind="props"
                @click="() => openCreateForm('Quotations', quotationsStore.createQuotation, 'Cotización')"
              >
                <v-icon size="24">mdi-file-document-multiple-outline</v-icon>
              </v-btn>
            </template>
            <span>Crear Cotización</span>
          </v-tooltip>
          <v-tooltip location="left" v-if="$can('activities.create')">
            <template #activator="{ props }">
              <v-btn color="grey" class="mb-2" icon v-bind="props"
                @click="() => openCreateForm('Activities', activitiesStore.createActivity, 'Actividad')"
              >
                <v-icon size="24">mdi-calendar</v-icon>
              </v-btn>
            </template>
            <span>Crear Actividad</span>
          </v-tooltip>
        </v-speed-dial>
      </v-fab>
    </v-card>
  </v-app>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed, shallowRef } from 'vue';
import { useRoute } from 'vue-router';
import { useOpportunitiesStore } from '@/store/opportunities';
import { usePreferencesStore } from '@/store/preferences';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/opportunities/opportunities.config';
import { useFloatFormStore } from '@/store/floatForm';
import { useSendFileDialogStore } from '@/store/sendFileDialog';
import { useSendersStore } from "@/store/senders";
import { useActivitiesStore } from '@/store/activities';
import { useQuotationsStore } from '@/store/quotations';
import { useDialogsStore } from '@/store/dialogs'
import { configRegistry } from '@/lib/configRegistry';
import { useBottomSheetStore } from '@/store/bottomSheet';

const props = defineProps<{ 
  id: number;
  onUpdate?: (data: any) => Promise<any>;
}>();
const emit = defineEmits(['close']);


const opportunity = ref<any>(null); // puedes tiparlo como Opportunity si lo tienes importado

const open = shallowRef(false)


const route = useRoute();
const moduleName = (route.meta.moduleName ?? route.name) as string;

const preferencesStore = usePreferencesStore();
const opportunitiesStore = useOpportunitiesStore();
const bottomSheetStore = useBottomSheetStore();

const allInteractions = ref<any[]>([]);
const selectedInteractionType = ref('Todo');

const selected_emails = ref<any[]>([]);

onMounted(async () => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find((header:any) => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );

  // 🔍 Cargar la oportunidad individual por ID
  const result = await opportunitiesStore.fetchOpportunityById(props.id + '?include=activities,quotations,sale,statuses');
  
  if (result) {
    const activities = result.activities.map((a: any) => ({ ...a, interaction_type: 'Actividad' }));
    const statuses = result.all_statuses.map((s: any) => ({ ...s, interaction_type: 'Status' }));
    const quotations = result.quotations.map((q: any) => ({ ...q, interaction_type: 'Cotización' }));
    const sale = result.sale ? [{ ...result.sale, interaction_type: 'Venta' }] : [];

    allInteractions.value = [...activities, ...statuses, ...quotations, ...sale].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    opportunity.value = result;
  }
});

const statusTime = computed(() => {
  if (!opportunity.value?.current_status?.created_at) return '';
  const from = new Date(opportunity.value.current_status.created_at);
  const now = new Date();
  const diff = Math.floor((now.getTime() - from.getTime()) / 3600000);
  return `${diff} horas`;
});

const groupedProductsByOrganization = computed(() => {
  const result: Record<string, any> = {};
  (opportunity.value?.products_of_interest || []).forEach((product: any) => {
    const orgId = product.organization.id;
    if (!result[orgId]) {
      result[orgId] = {
        organization: product.organization,
        products: [],
      };
    }
    result[orgId].products.push(product);
  });
  return Object.values(result);
});

const interactionTypes = computed(() => {
  return [
    { label: 'Todo', value: 'Todo', count: allInteractions.value.length },
    { label: 'Actividad', value: 'Actividad', count: allInteractions.value.filter(i => i.interaction_type === 'Actividad').length },
    { label: 'Status', value: 'Status', count: allInteractions.value.filter(i => i.interaction_type === 'Status').length },
    { label: 'Cotización', value: 'Cotización', count: allInteractions.value.filter(i => i.interaction_type === 'Cotización').length },
    { label: 'Venta', value: 'Venta', count: allInteractions.value.filter(i => i.interaction_type === 'Venta').length }
  ];
});

const filteredInteractions = computed(() => {
  if (selectedInteractionType.value === 'Todo') return allInteractions.value;
  return allInteractions.value.filter(i => i.interaction_type === selectedInteractionType.value);
});

const floatFormStore = useFloatFormStore();

const onUpdate = props?.onUpdate;

const editItem = (item: any) => {
  floatFormStore.openForm({
    component: 'EditForm',
    formTitle: 'Editar Oportunidad',
    formWidth: '1080',
    module: 'Opportunities',
    props: {
      item,
      onUpdate: onUpdate
    }
  });
};

const deleteItem = (item: any) => {
  bottomSheetStore.openSheet({
    module: 'Opportunities',
    formTitle: `¿Seguro(a) que deseas eliminar Oportunidad ${item?.id}?`,
    props: {
      item,
      message: 'Esta acción no se puede deshacer.',
      action: async () => {
        await opportunitiesStore.deleteOpportunity(item?.id);
        emit('close');
      },
    },
  });
};

const changeStatusToLose = async (item_id: any) => {
  if (onUpdate) {
    await onUpdate({id:item_id, status:'Oportunidad cerrada perdida'});
  } else {
      console.warn('[EditForm] No se proporcionó función onUpdate');
    }
};

const sendFileDialogStore = useSendFileDialogStore();
const sendersStore = useSendersStore();

const sendMediaKit = (item: any) => {
  sendFileDialogStore.openForm({
    formTitle: 'Enviar Media Kit',
    main_email: item?.subject?.attributes?.email,
    main_whatsapp:  item?.subject?.attributes?.phone,
    client_id: item?.subject?.type === 'clients' ? item?.subject?.id : undefined,
    onSendEmail: sendersStore.sendEmailWithMediaKit,
    onSendWhatsapp: sendersStore.sendWhatsAppWithMediaKit,
  });
};

const activitiesStore = useActivitiesStore();
const quotationsStore = useQuotationsStore();

function openCreateForm(createModuleName:any, onCreate:any, label:any) {
  floatFormStore.openForm({
    component: 'CreateForm',
    formTitle: 'Crear ' + label,
    formWidth: '1080',
    module: createModuleName,
    props: {
      onCreate,
      initialValues: {
        subject: opportunity.value?.subject,
        opportunity: opportunity.value
      }
    }
  });
}


const copyLink = async () => {
  // Toma el path actual y reemplaza el id por el del cliente seleccionado (si aplica)
  let path = route.fullPath;

  // Si el path ya tiene un id en los params, cámbialo por el id del cliente actual
  if (route.params.id) {
    path = path.replace(`${route.params.id}`, `${opportunity.value?.id}`);
  } else if (!path.endsWith(`/${opportunity.value?.id}`)) {
    // Si no tiene id en la ruta, se lo agrega al final
    path = path.replace(/\/$/, '') + `/${opportunity.value?.id}`;
  }

  const baseUrl = window.location.origin;
  const fullUrl = baseUrl + path;

  try {
    await navigator.clipboard.writeText(fullUrl);
    // Opcional: Snackbar, toast, etc
    // alert('¡Enlace copiado!');
  } catch (err) {
    alert('No se pudo copiar el enlace');
  }
};

const dialogsStore = useDialogsStore();

const openDetailDialog = async (id: any, moduleName: string) => {
  const loader = configRegistry[moduleName];
  let component: any;
  if (loader) {
    const mod = await loader();
    component = mod?.DETAIL?.component;
  } else {
    console.warn(`[${moduleName}] No se encontró DETAIL.component en configRegistry`);
    return;
  }
  dialogsStore.open(
    moduleName,
    id,
    {
      id
    }
  );
};

</script>
